var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraBlk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.6 21.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8,4.05v13.5h18V4.05Zm16.9,12.4H2.9V5.25H18.7Zm-6.2-1.7a3.9,3.9,0,0,0,3.9-3.9A4,4,0,0,0,12.5,7a3.9,3.9,0,0,0-3.9,3.9A3.84,3.84,0,0,0,12.5,14.75Zm0-6.7a2.8,2.8,0,1,1-2.8,2.8A2.73,2.73,0,0,1,12.5,8.05Zm-8.4-.6a1.1,1.1,0,1,1,1.1,1.1A1.1,1.1,0,0,1,4.1,7.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBlk);
export default __webpack_public_path__ + "static/media/camera_blk.c0a363e756ba55b6e34042151a98a3f1.svg";
export { ForwardRef as ReactComponent };